import axios from 'axios';

import { MemberResponse, Member } from 'services/api/member/types';

import { getMemberMockByTier } from 'helpers/mock';

export const getMember = async (apiDomain: string): Promise<Member> => {
  const smilesGetMemberUrl = `${apiDomain}/members/v1/members`;
  const JWTToken = localStorage.getItem('session-token');
  const vbzDebug = localStorage.getItem('vbzDebug');

  if (vbzDebug) {
    return getMemberMockByTier(vbzDebug);
  }

  return axios
    .get<MemberResponse>(smilesGetMemberUrl, {
      headers: {
        Authorization: `Bearer ${JWTToken}`,
        'Content-Type': 'application/json',
      },
    })
    .then((response) => response.data.member)
    .catch((error) => error);
};
